import { isValidValue } from "utils";


export const setIdp = (el = null) => {
  if (!isValidValue(el)) return null;
  return {
    metadata_url: el.metadata_url,
    email: el.attribute_mapping.email,
    first_name: el.attribute_mapping.first_name,
    last_name: el.attribute_mapping.last_name,
    name: el.attribute_mapping.name,
    title: el.attribute_mapping.title,
    phone: el.attribute_mapping.phone,
    role: el.attribute_mapping.role,
    logout_url: el.logout_url || "",
  };
};
